// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__Yoh9T","popup_content":"popup_popup_content__gdu7i","popup_content_container":"popup_popup_content_container__wkBxg","popup_close":"popup_popup_close__Oge3q"};